import React  from "react"
import {IonAccordionGroup, IonCol, IonGrid, IonList, IonRow} from "@ionic/react";

import {TimeLimit} from "../../types/TimeLimit"

import {useLockingSystems} from "../../contexts/LockingSystemContext";

import FormAccordionTimeLimit from "../TimeLimits/Form/AccordionTimeLimit";
import FormAccordionTimeLimitData from "../TimeLimits/Form/AccordionTimeLimitData";
import {useTimeLimits} from "../../contexts/TimeLimitContext";
import {useHistory} from "react-router";
import FormButtonSaveChanges from "../common/Buttons/FormButtonSaveChanges";
import FormButtonSaveNew from "../common/Buttons/FormButtonSaveNew";

interface formProps {
    item: TimeLimit | undefined;
}

const Form: React.FC<formProps> = ({ item }) => {

    const history = useHistory()
    const {selectedLockingSystemId} = useLockingSystems()
    const {addItem, editItem, message} = useTimeLimits()

    const initialFormData: TimeLimit = {
        id:                  item?.id          || 0,
        description:         item?.description || '',
        name:                item?.name        || '',
        startDate:           item?.startDate?.replace(' ', 'T') || '',
        endDate:             item?.endDate?.replace(' ', 'T') || '',
        lockingSystemId:     item?.lockingSystemId     || selectedLockingSystemId || 0,
        lockingSystemZoneId: item?.lockingSystemZoneId || 0,
        timeLimitData:       item && item.timeLimitData?.length ? item.timeLimitData : []
    }

    const [formData, setFormData] = React.useState(initialFormData)
    const accordionGroupRef = React.useRef<null | HTMLIonAccordionGroupElement>(null)

    React.useEffect(() => {
        if (! item && formData.lockingSystemId === 0) {
            setFormData({ ...formData, lockingSystemId: selectedLockingSystemId || 0 })
        }

    }, [item, selectedLockingSystemId])

    React.useEffect(() => {
        setFormData(initialFormData)

        if (! accordionGroupRef.current) return

        accordionGroupRef.current.value = ['timeLimit', 'timeLimitData']
    }, [item])

    const updateFormHandler = React.useCallback(
        (type: any) => (event: any) => {
            setFormData({ ...formData, [type]: event.target.value })
        }, [formData]
    )

    const handleSave = async (e: any) => {
        e.preventDefault()
        e.stopPropagation()

        if (item?.id) {
            const result = await editItem(formData)

            if (result !== undefined || message !== undefined) {
                if (result) {
                    history.push('/time-limits/' + formData.id + '/view')
                    return
                }
            }
        } else {
            const newTimeLimit = await addItem(formData)

            if (newTimeLimit) {
                setFormData(initialFormData)

                history.push('/time-limits/' + newTimeLimit.id + '/view')
            }
        }
    }

    const FormKeyUp = (e: any) => {
        if (e.key === 'Enter') handleSave(e);
    }

    const canSave = (): boolean => {
        if ((formData.timeLimitData && formData.timeLimitData?.length > 0)
            || (formData.startDate && formData.startDate.length > 1)
            || (formData.endDate && formData.endDate.length > 1)
        ) {
            return true
        }

        return false
    }

    return (
        <IonList className="maxWidth">
            <form method="POST" id="formTimeLimit" onSubmit={handleSave} onKeyUp={ e => FormKeyUp(e) }>

            <IonAccordionGroup multiple={true} ref={accordionGroupRef}>
                <FormAccordionTimeLimit formData={formData} setFormData={setFormData}
                                        updateFormHandler={updateFormHandler} />
                <FormAccordionTimeLimitData formData={formData} setFormData={setFormData}
                                        updateFormHandler={updateFormHandler}
                />
            </IonAccordionGroup>

            {canSave() &&
            <IonGrid className="ion-margin-top">
                <IonRow>
                    <IonCol className="ion-text-right">
                        {item?.id ? <FormButtonSaveChanges /> : <FormButtonSaveNew />}
                    </IonCol>
                </IonRow>
            </IonGrid>
            }

            </form>
        </IonList>
    )
}

export default Form